




















import { Component, Vue } from 'vue-property-decorator';
import { AccountRegisterModel, AppUserLoginModel } from '@/services/api/nswag/stapiclient_generated';
import { stAuthenticationApi } from '@/services/st-api';
import { resetGlobalData } from '@/store/global-data-helper';
import StInput2 from '@/components/basic/StInput2.vue';

@Component({
  components: {
    StInput2,
  },
})
export default class Register extends Vue {
  private registerModel: AccountRegisterModel = AccountRegisterModel.fromJS({});
  private loading: boolean = false;
  private exists: any = '0';

  created() {
    this.exists = this.$route.query.exists;
  }

  mounted() {
    resetGlobalData();
  }

  async submit() {
    this.loading = true;
    try {
      await stAuthenticationApi.register(this.registerModel);
      await this.$router.push('/');
    } finally {
      this.loading = false;
    }
  }
}
